import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  light?: boolean;
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  const base = light ? "text-white/60" : "text-foreground-500";
  const current = light ? "text-white/90" : "text-foreground-800";
  const link = light
    ? "text-white/60 hover:text-white transition-colors cursor-pointer"
    : "text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer";
  const divider = light ? "text-white/40" : "text-foreground-300";
  return (
    <nav aria-label="面包屑导航" className={`flex items-center flex-wrap gap-1.5 text-sm ${base}`}>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && <i className={`ri-arrow-right-s-line ${divider}`} />}
          {item.to ? (
            <Link to={item.to} className={link}>
              {item.label}
            </Link>
          ) : (
            <span className={current}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}